const textureMappings = {
    'christmasTree': 'tree.jpg',
    'wreaths1': 'wreath1.jpg',
    'wreaths2': 'wreath2.jpg',
    'wreaths3': 'wreath3.jpg',
    'wreaths4': 'wreath4.jpg',
    'rocks': 'rocks.jpg',
    'objects': 'objects0.jpg',
    'objects001': 'objects1.jpg',
    'objects002': 'objects2.jpg',
    'objects003': 'objects3.jpg',
    'objects004': 'objects4.jpg',
    'objects005': 'objects5.jpg',
    'objects006': 'objects6.jpg',
    'present': 'presents0.jpg',
    'present001': 'presents1.jpg',
    'present002': 'presents2.jpg',
    'present003': 'presents3.jpg',
    'present004': 'presents4.jpg',
    'present005': 'presents5.jpg',
    'rocks': 'rocks.jpg',
    'backwall+woodframes': 'backwall.jpg',
    'floors+handrails': 'floor.jpg',
    'sidewall': 'sidewall.jpg',
    'stairs': 'stairs.jpg',
    'elf': 'elves.jpg',
}

export default textureMappings
